export default __webpack_public_path__ + "static/media/laporan-karyawan.a36a1307.png";